import { castArray, gen, isArray, toSumByKey } from '../../views/utils'

export default {
  auto: '*',
  store: {
    state: {
      contextJobs: [],
    },
    getters: {
      joblist: state => state.contextJobs,

      // jobsStatuses: () => ({
      //   NOT: { name: 'Not started' },
      //   PRO: { name: 'In Progress' },
      //   DON: { name: 'Done' },
      // }),
      // jobsStatusOptions: statusOptions('jobStatuses'),

      genJob: gen(() => ({
        status: null,
        description: '',
        eventId: null,
        workerId: null,
        jobTypeId: null,
        name: '',
        price: null,
        priceParts: null,
        units: 1,
        time: null,
      })),

      joblistPrice: ({ contextJobs }, { groupSettings }) => ({ isOnlyDone, isVatIncluded }) => {
        const includedJobs = isOnlyDone
          ? contextJobs.filter(job => job.status === 'DON')
          : contextJobs

        const priceWork = includedJobs.reduce(toSumByKey('price'), 0)
        const priceParts = includedJobs.reduce((sum, { priceParts, units }) =>
          sum + (priceParts * (units || 1)), 0)

        if (isVatIncluded) return priceWork + priceParts

        const vatPartsMultiplier = 100 + groupSettings.vatParts
        const vatWorkMultiplier = 100 + groupSettings.vatWork

        return Number((Math
          .round((priceParts * vatPartsMultiplier + priceWork * vatWorkMultiplier)) / 100)
          .toFixed(2))
      },
    },

    actions: {
      POP_JOBLIST({ commit }, index = 0) {
        commit('POP_JOBLIST', index)
      },
      PUSH_JOBLIST({ commit, getters, state }, job = {}) {
        commit('PUSH_JOBLIST', isArray(job) ? job : getters.genJob(job))
      },
      SET_JOBLIST({ commit }, joblist) {
        commit('SET_JOBLIST', joblist)
      },
    },

    mutations: {
      POP_JOBLIST(state, index) {
        state.contextJobs.splice(index, 1)
      },
      PUSH_JOBLIST(state, jobs) {
        castArray(jobs).forEach((job) => {
          if (!state.contextJobs.some(({ id, name }) =>
            (id && id === job.id) || name === job.name)) {
            state.contextJobs.push(job)
          }
        })
      },
      RESET_JOBLIST(state) {
        state.contextJobs = []
      },
      SET_JOBLIST(state, joblist) {
        state.contextJobs = joblist
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/jobs.js